/* eslint-disable new-cap */
import { Box, Flex } from '@gusto/workbench';
import useResponsive from 'packages/signup/helpers/useResponsive';
import trackingEvents from 'helpers/trackingEvent';
import PrivacyLogo from '../../../images/icons/your-privacy-choices.svg';

export default function LegalFooter() {
  const actualYear = new Date().getFullYear();
  const { isTablet } = useResponsive();

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      className={isTablet ? 'legalFooter__mobile' : 'legalFooter'}
    >
      <Box className="legalFooter__container">
        Gusto © <span className="legalFooter__container--year">{actualYear}</span> {'  '}
        <a
          href="/about/privacy"
          target="_blank"
          onClick={() => {
            trackingEvents('Dom', 'Click', 'footerPrivacy', 'Privacy');
          }}
        >
          Privacy
        </a>
        <button
          type="button"
          className="privacy-btn"
          onClick={() => (window as any).OneTrust.ToggleInfoDisplay()}
        >
          Your Privacy Choices
          <img
            src={PrivacyLogo}
            alt="privacy choices graphic"
            style={{ width: '36px', height: '16px', marginLeft: '5px', marginBottom: '3px' }}
          />
        </button>
        <a
          href="/about/terms"
          target="_blank"
          onClick={() => {
            trackingEvents('Dom', 'Click', 'footerTerms', 'Terms');
          }}
        >
          Terms
        </a>
      </Box>
    </Flex>
  );
}
